/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit';

import { selectIsNewIa } from '@ibm-watson/shared/modules/ia/store/instance/selectors';
import { ApiStatus } from '../../../../../ts';
import { CreateAsyncThunk, SkillsSlice } from '../../../../../ts/state';
import * as API from '../../../api/skills';
import { getErrorString } from '../../../util/errorHandler';
import { deletedObjectEvents } from '../../../util/trackers/segment';
import { addErrorMessage } from '../../messages/actions';
import { entityAdapter } from '../adapter';

export const deleteSkill = createAsyncThunk<string, string, CreateAsyncThunk>(
  'skills/delete',
  async (id, { dispatch, getState }) => {
    try {
      const new_ia = selectIsNewIa(getState());
      await API.deleteSkill(id, { new_ia });
      deletedObjectEvents.skill({
        object: id,
        resultValue: 'success',
        successFlag: true
      });
      return id;
    } catch (error) {
      dispatch(addErrorMessage(error));
      deletedObjectEvents.skill({
        object: id,
        resultValue: getErrorString(error),
        successFlag: false
      });
      throw error;
    }
  }
);

const reducer = (builder: ActionReducerMapBuilder<SkillsSlice>) => {
  builder
    .addCase(deleteSkill.pending, (state, _action) => {
      state.deleteStatus = ApiStatus.LOADING;
      state.deleteError = null;
    })
    .addCase(deleteSkill.fulfilled, (state, action) => {
      state.deleteStatus = ApiStatus.SUCCEEDED;
      state.deleteError = null;
      entityAdapter.removeOne(state, action.payload);
    })
    .addCase(deleteSkill.rejected, (state, action) => {
      state.deleteStatus = ApiStatus.ERROR;
      state.deleteError = action.error;
    });
};

export default reducer;
